import { map } from 'lodash';
import { all, takeEvery } from 'redux-saga/effects';
import { SUBJECT_MAPPING } from './constants/types';
import { getUserSubjects } from './reducers/subject';
import { PREAP_SUBJECTS } from 'chameleon-src/constants/subjects';

export function* remapSubjectsSaga(
  action,
  getUserSubjectsFn = getUserSubjects,
) {
  const { userData, router, params } = action;
  const userSubjects = getUserSubjectsFn(userData);
  let mapId = 'id';
  if (userData.isAdmin || userData.isCoordinator) {
    mapId = 'masterSubjectId';
  }
  const subjectIds = map(userSubjects, (item) => item[mapId].toString());

  if (
    (userSubjects || []).length &&
    !Number.isNaN(parseInt(params.subject, 10)) &&
    !subjectIds.includes(params.subject)
  ) {
    if (subjectIds.includes('77') && params.subject === '24') {
      yield router.replace('/77/home');
    } else if (!PREAP_SUBJECTS.includes(parseInt(params.subject, 10))) {
      yield router.replace('/error/1');
    }
  }
}

export default function* entrypointSaga() {
  yield all([takeEvery(SUBJECT_MAPPING, remapSubjectsSaga)]);
}
